<template>
  <el-menu
    class="menu-nav"
    router
    :default-active="$route.path"
    :default-openeds="defaultOpeneds"
    background-color="#20222A"
    text-color="rgba(255,255,255,.8)"
    active-text-color="#ffd04b"
    :collapse="isCollapse"
  >
    <el-menu-item index="/home">
      <i class="el-icon-s-home"></i>
      <span slot="title">首页</span>
    </el-menu-item>
    <el-menu-item v-if="showScreen" index="/screen">
      <i class="el-icon-monitor"></i>
      <span slot="title">智慧养老大屏</span>
    </el-menu-item>
    <template v-for="i in renderRoles">
      <el-submenu v-if="i.__projectOrder" :key="i.url || '__projectOrder'" index="__projectOrder">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span>项目订单管理</span>
        </template>
        <el-menu-item v-for="c in projectOrderChildren" :key="c.url" :index="c.url">
          <i :class="c.icon || ''"></i>
          <span slot="title">{{ c.name }}</span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item v-else :key="i.url" :index="i.url">
        <i :class="i.icon || ''"></i>
        <span slot="title">{{ i.name }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import { hasScreenPermission, isScreenMenu } from '@/utils/util'

const PROJECT_ORDER_URLS = [
  '/orders',
  '/orders_',
  '/orders_tk',
  '/orders_sn',
  '/orders_tf',
  '/orders_foster',
  '/orders_foster_records',
  '/orders_boarding'
]

const BOARDING_MENU = {
  url: '/orders_boarding',
  name: '残疾人寄宿托养服务',
  icon: 'el-icon-s-home'
}

export default {
  props: ['isCollapse'],
  data() {
    return {}
  },
  computed: {
    roles() {
      return this.$store.state.rules
    },
    showScreen() {
      return hasScreenPermission(this.roles)
    },
    projectOrderChildren() {
      const roles = this.roles || []
      const list = roles.filter(i => PROJECT_ORDER_URLS.indexOf(i.url) > -1)
      const byUrl = {}
      list.forEach(i => { byUrl[i.url] = i })
      // 寄宿托养按权限显示：账号拥有该菜单（按名称或 url 匹配）才展示
      const hasBoarding = roles.some(i => i && i.name && i.name.indexOf('寄宿托养') > -1) || !!byUrl['/orders_boarding']
      const result = []
      PROJECT_ORDER_URLS.forEach(url => {
        if (url === '/orders_boarding') {
          if (hasBoarding) result.push(BOARDING_MENU)
        } else if (byUrl[url]) {
          result.push(byUrl[url])
        }
      })
      return result
    },
    renderRoles() {
      const roles = (this.roles || []).filter(i => !isScreenMenu(i))
      const result = []
      let inserted = false
      // 仅当账号拥有任意项目订单子权限时才显示「项目订单管理」
      if (this.projectOrderChildren.length === 0) {
        return roles
      }
      for (const i of roles) {
        // 跳过寄宿托养父级菜单（由项目订单管理子菜单统一展示）
        if (i && i.name && i.name.indexOf('寄宿托养') > -1) {
          if (!inserted) {
            result.push({ __projectOrder: true })
            inserted = true
          }
          continue
        }
        if (PROJECT_ORDER_URLS.indexOf(i.url) > -1) {
          if (!inserted) {
            result.push({ __projectOrder: true })
            inserted = true
          }
        } else {
          result.push(i)
        }
      }
      return result
    },
    defaultOpeneds() {
      const path = this.$route.path || ''
      return path.indexOf('/orders') === 0 && this.projectOrderChildren.length ? ['__projectOrder'] : []
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
  .el-menu {
    border: none;
  }

  .menu-nav:not(.el-menu--collapse) {
    width: 230px;
    min-height: 400px;
  }
</style>
